enum ActionTypes {
	request = 'SiMaxPrice.request',
	receive = 'SiMaxPrice.receive',
	requestUpdate = 'SiMaxPrice.requestUpdate',
	receiveUpdate = 'SiMaxPrice.receiveUpdate',
	scheduleUpdate = 'SiMaxPrice.scheduleUpdate',
	requestXlsCreate = 'SiMaxPrice.requestXlsCreate',
	receiveXlsCreate = 'SiMaxPrice.receiveXlsCreate',
	requestProductTypes = 'SiMaxPrice.requestProductTypes',
	receiveProductTypes = 'SiMaxPrice.receiveProductTypes',
	prune = 'SiMaxPrice.prune',
}

export default ActionTypes;
